"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createDevice = void 0;

var getSize = function getSize(breakpointValue) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof breakpointValue === 'string') {
    if (breakpoints[breakpointValue] !== undefined) {
      return breakpoints[breakpointValue];
    }

    var parsedNumber = parseInt(breakpointValue);

    if (parsedNumber) {
      return parsedNumber;
    }
  }

  if (typeof breakpointValue === 'number') {
    return breakpointValue;
  }

  throw new Error('Breakpoint is not supported.');
};

var withMinMedia = function withMinMedia(minWidth, unit) {
  return "@media (min-width: ".concat(minWidth).concat(unit, ")");
};

var withMaxMedia = function withMaxMedia(maxWidth, unit) {
  return "@media (max-width: ".concat(maxWidth - 1).concat(unit, ")");
};

var withMinMaxMedia = function withMinMaxMedia(minWidth, maxWidth, unit) {
  return "@media (min-width: ".concat(minWidth).concat(unit, ") and (max-width: ").concat(maxWidth - 1).concat(unit, ")");
};

var createDevice = function createDevice(minWidth, maxWidth) {
  return {
    min: minWidth,
    max: maxWidth
  };
};

exports.createDevice = createDevice;

var createMedia = function createMedia(breakpoints, devices) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'px';

  var down = function down(value) {
    var device = devices[value];

    if (device) {
      var minWidth = device.min;

      if (!device.min || device.min === 0) {
        throw new Error('Device min should be greater then 0');
      }

      return withMaxMedia(minWidth, unit);
    }

    var maxSize = getSize(value, breakpoints);
    return withMaxMedia(maxSize, unit);
  };

  var up = function up(value) {
    var device = devices[value];

    if (device) {
      var _minSize = device.max || device.min;

      return withMinMedia(_minSize, unit);
    }

    var minSize = getSize(value, breakpoints);
    return withMinMedia(minSize, unit);
  };

  var between = function between(firstValue, secondValue) {
    var firstDevice = devices[firstValue];
    var secondDevice = devices[secondValue];

    if (firstDevice && secondDevice) {
      var _minSize2 = firstDevice.max || firstDevice.min;

      var _maxSize = secondDevice.min || secondDevice.max;

      return withMinMaxMedia(_minSize2, _maxSize, unit);
    }

    if (firstDevice) {
      var _minSize3 = firstDevice.min || firstDevice.max;

      return withMinMaxMedia(_minSize3, getSize(secondValue, breakpoints), unit);
    }

    if (secondDevice) {
      var _maxSize2 = secondDevice.max || secondDevice.min;

      return withMinMaxMedia(getSize(firstValue, breakpoints), _maxSize2, unit);
    }

    var minSize = getSize(firstValue, breakpoints);
    var maxSize = getSize(secondValue, breakpoints);
    return withMinMaxMedia(minSize, maxSize, unit);
  };

  var only = function only(value) {
    var device = devices[value];

    if (!device) {
      throw new Error("".concat(value, " device not registered"));
    }

    var minSize = device.min;
    var maxSize = device.max;

    if (minSize && maxSize) {
      return withMinMaxMedia(minSize, maxSize, unit);
    }

    if (minSize) {
      return withMinMedia(minSize, unit);
    }

    if (maxSize) {
      return withMaxMedia(maxSize, unit);
    }
  };

  return {
    down: down,
    up: up,
    between: between,
    only: only
  };
};

var _default = createMedia;
exports["default"] = _default;